import { Box, SxProps, Theme } from '@mui/material';
import { ReactElement } from 'react';
import { ExpandMoreIcon } from '../../assets/icons';

export interface ExpandIconProps {
  open?: boolean;
  className?: string;
  sx?: SxProps<Theme>;
}

export function ExpandIcon({ open, className, sx }: Readonly<ExpandIconProps>): ReactElement<ExpandIconProps> {
  return (
    <Box
      component="span"
      className={className}
      sx={[
        (theme) => ({
          transition: theme.transitions.create('transform'),
          transform: open ? 'rotateX(180deg)' : undefined,
        }),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <ExpandMoreIcon />
    </Box>
  );
}
